import * as yup from 'yup';
export const productDetailSchema = yup.object({
  productName: yup.string(),
  category: yup.string(),
  parentBrand: yup.string(),
  subBrand: yup.string(),
  pack: yup.number(),
  baseUOM: yup.string(),
  sgst: yup.number(),
  igst: yup.number(),
  cgst: yup.number(),
  materialGroup: yup.string(),
  hsnCode: yup.string(),
  productCount: yup.number(),
  productWeight: yup.number(),
  videoProduct: yup.string(),
  selectedMissingInfo: yup.string(),
});

export type TProductFormData = yup.InferType<
  typeof productDetailSchema
>;

export const productInfosSchema = yup.object({
  productInfoArray: yup.array().of(
    yup.object({
      header: yup.string(),
      value: yup
        .string()
        .nullable()
        .required('value is required'),
      // .when('isDeletable', {
      //   is: false,
      //   then: yup.string().required(),
      // }),
      valueType: yup.string(),
      options: yup.array(),
      isEditable: yup.boolean(),
      isDeletable: yup.boolean(),
    })
  ),
  missingInfoArray: yup.array().of(
    yup.object({
      header: yup.string(),
      value: yup.string().default(''),
      valueType: yup.string(),
      options: yup.array(),
      isEditable: yup.boolean(),
      isDeletable: yup.boolean(),
    })
  ),
});

export type TProductInfoData = yup.InferType<
  typeof productInfosSchema
>;
